export const getApiKey = () => {
  return '9ddc5bc7a67ec7678e2b824567dbfaed7e1b2855'
}
